var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passage-lemma-traversal-widget"},[(_vm.lemmas && _vm.versionUrn)?_c('PassageLemmaTraversal',{attrs:{"lemmas":_vm.lemmas,"versionUrn":_vm.versionUrn,"passage":_vm.passage},on:{"clear":_vm.clearSelectedLemma}}):_c('EmptyMessage',[_vm._v(" No lemma selected ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }